import { Form } from '@/services/form';
import trackingMixins from '@/mixins/tracking/sdk';
import { API_URLS } from '@/api/pumba/urls';

const formSpecialist = {
    // User
    name: '',
    phone: '',
    email: '',
    email_confirmation: '',

    // Company
    company_name: '',
    social_media_url: '',

    // Company infos
    company_type: '',
    company_services: '',
    client_operation: '',

    // Mixpanel distinct_id
    distinct_id: '',
};

export const state = {
    // The specialist form
    form: new Form(formSpecialist),

    companyArrayServices: {
        company_services: [],
        client_operation: [],
    },

    otherInputValues: {
        company_services: {
            value: '',
            isRequired: false,
        },

        client_operation: {
            value: '',
            isRequired: false,
        },
    },

    formLoading: false,
};

export const getters = {
    // Form to create a specialist
    $form_create_specialist: (states) => states.form,

    $company_array_services: (states) => states.companyArrayServices,

    $form_loading: (states) => states.formLoading,

    $company_service_input_required: (states) => states.otherInputValues.company_services.isRequired,

    $client_operation_input_required: (states) => states.otherInputValues.client_operation.isRequired,
};

export const mutations = {
    ['UPDATE_FORM_FIELD'](states, { field, value }) {
        states.form[field] = value;
    },

    ['UPDATE_COMPANY_ARRAY_VALUES'](states, { field, newArray }) {
        states.companyArrayServices[field] = newArray;
    },

    ['UPDATE_OTHER_INPUT_COMPANY'](states, { field, value }) {
        states.otherInputValues[field].isRequired = false;

        states.otherInputValues[field].value = value;
    },

    ['UPDATE_OTHER_INPUT_REQUIRED'](states, { field, value }) {
        states.otherInputValues[field].isRequired = value;
    },

    ['RESET_FORM'](states) {
        states.form.reset();
    },

    ['UPDATE_FORM_LOADING'](states, value) {
        states.formLoading = value;
    },
};

export const actions = {
    async submitForm({ state: states, dispatch, commit }) {
        const { distinct_id } = trackingMixins.data();

        try {
            commit('UPDATE_FORM_LOADING', true);

            commit('UPDATE_FORM_FIELD', {
                field: 'distinct_id',
                value: distinct_id,
            });

            dispatch('formatCompanyService');
            dispatch('formatClientOperation');

            await states.form.post(API_URLS.SPECIALIST.POST);

            dispatch('resetForm');
        } finally {
            commit('UPDATE_FORM_LOADING', false);
        }
    },

    updateFormField({ commit }, { field, value }) {
        commit('UPDATE_FORM_FIELD', { field, value });
    },

    formatCompanyService({ commit, state: states }) {
        if (states.otherInputValues.company_services.value) {
            states.companyArrayServices.company_services.push(states.otherInputValues.company_services.value);
        }

        const finalServicesValues = states.companyArrayServices.company_services.join(', ');

        commit('UPDATE_FORM_FIELD', { field: 'company_services', value: finalServicesValues });
    },

    formatClientOperation({ commit, state: states }) {
        if (states.otherInputValues.client_operation.value) {
            states.companyArrayServices.client_operation.push(states.otherInputValues.client_operation.value);
        }

        const finalClientOperationValues = states.companyArrayServices.client_operation.join(', ');

        commit('UPDATE_FORM_FIELD', { field: 'client_operation', value: finalClientOperationValues });
    },

    resetForm({ commit }) {
        commit('UPDATE_COMPANY_ARRAY_VALUES', { field: 'company_services', newArray: [] });
        commit('UPDATE_COMPANY_ARRAY_VALUES', { field: 'client_operation', newArray: [] });

        commit('UPDATE_OTHER_INPUT_COMPANY', { field: 'company_services', value: '' });
        commit('UPDATE_OTHER_INPUT_COMPANY', { field: 'client_operation', value: '' });

        commit('RESET_FORM');
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
